import { Button } from '@/components/ui/button';

export function Cta({ onJoinWaitlist }: { onJoinWaitlist: (location: string) => void }) {
  return (
    <section id="waitlist" className="relative isolate overflow-hidden border-t border-white/8">
      <div className="mkt-hero-glow absolute inset-0 -z-10" aria-hidden />
      <div className="mx-auto max-w-6xl px-6 py-24 text-center sm:py-32">
        <p className="mkt-mono mb-6 text-[11px] uppercase tracking-[0.28em] text-[color:var(--nq-blue-bright)]">
          The waitlist is open
        </p>
        <h2 className="mx-auto max-w-3xl font-display text-[clamp(2.2rem,5.5vw,4rem)] font-bold leading-[1.02] tracking-[-0.03em] text-foreground">
          Wall Street’s discipline.{' '}
          <span className="text-[color:var(--nq-gold)]">Your brokerage account.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-muted-foreground">
          Be first to know when the NovaQuantis ETF launches. No spam — just the
          launch, the methodology, and early access.
        </p>
        <div className="mt-9 flex justify-center">
          <Button size="lg" onClick={() => onJoinWaitlist('cta')}>
            Join the waitlist
          </Button>
        </div>
      </div>
    </section>
  );
}
